import UniformAccordion from '../../../../../../uniform/components/accordion/src/accordion.tsx';

export interface EmbeddedQuestionData {
	title: string;
	anchorId?: string;
	content: string;
}

export interface EmbeddedQuestionProps {
	data: unknown;
}

export const EmbeddedQuestion = (props: EmbeddedQuestionProps) => {
	const { data } = props;
	const { title, anchorId, content } = data as EmbeddedQuestionData;
	return <UniformAccordion header={title} anchorId={anchorId} richText={content} />;
};
